import { render, staticRenderFns } from "./PersonhistSelect.vue?vue&type=template&id=2bc15c98&"
import script from "./PersonhistSelect.vue?vue&type=script&lang=js&"
export * from "./PersonhistSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports